import { z } from 'zod'
import { ROLES } from './permissions.ts'

const profileFields = {
  name: z.string().trim().min(1).max(200),
  title: z.string().trim().min(1).max(200),
  email: z.string().trim().toLowerCase().max(254).pipe(z.email()),
  phone: z.string().trim().max(100).nullable(),
  workCenter: z.string().trim().min(1).max(200).nullable(),
  workCenters: z
    .array(z.string().trim().min(1).max(200))
    .max(50)
    .refine((values) => new Set(values).size === values.length)
    .optional(),
}

export const staffReferenceSchema = z.object({
  id: z.string().min(1),
  version: z.number().int().positive(),
})
export const staffCreateSchema = z
  .object({
    ...profileFields,
    role: z.enum(ROLES),
    password: z.string().min(12).max(128).optional(),
  })
  .strict()
export const staffPatchSchema = z
  .object(profileFields)
  .partial()
  .strict()
  .refine((patch) => Object.keys(patch).length > 0)
export const staffUpdateSchema = staffReferenceSchema.extend({ patch: staffPatchSchema }).strict()
export const staffRoleSchema = staffReferenceSchema.extend({ role: z.enum(ROLES) }).strict()
export const staffDisableSchema = staffReferenceSchema
  .extend({
    handoverToId: z.string().min(1).nullable(),
    reason: z.string().trim().min(1).max(500),
  })
  .strict()
export const staffCommandSchema = staffReferenceSchema.strict()
export const staffPasswordSchema = staffReferenceSchema
  .extend({
    password: z.string().min(12).max(128).optional(),
  })
  .strict()

export type StaffCreateInput = z.infer<typeof staffCreateSchema>
export type StaffPatch = z.infer<typeof staffPatchSchema>
export type StaffUpdateInput = z.infer<typeof staffUpdateSchema>
export type StaffRoleInput = z.infer<typeof staffRoleSchema>
export type StaffDisableInput = z.infer<typeof staffDisableSchema>
export type StaffCommandInput = z.infer<typeof staffCommandSchema>
export type StaffPasswordInput = z.infer<typeof staffPasswordSchema>
